import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTableModule } from 'ng-zorro-antd/table';

import { MFieldIconComponent } from './field-icon.component';
import { MFieldsComponent } from './field-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzTableModule,
    NzSelectModule,
    NzSpaceModule,
    NzInputModule,
    NzIconModule,
    NzCheckboxModule
  ],
  declarations: [MFieldsComponent, MFieldIconComponent],
  exports: [MFieldsComponent, MFieldIconComponent],
  providers: []
})
export class MFieldsModule {}
